import { apiPaths } from './config/apiPaths';
import { postJson } from './postClient';

/**
 * Normalize saga/UI payload into automation-manager request body.
 * @param {{ operation?: string, payload?: object }} inputData
 */
export function buildWorkflowRequestBody(inputData = {}) {
  return {
    operation: inputData.operation,
    payload: inputData.payload ?? {},
  };
}

/**
 * POST to /orchestrator/automation-manager with { operation, payload }.
 * @param {object} inputData - { operation, payload? }
 * @param {object} authHeaders
 * @param {string} defaultError
 */
export function workflowChannelRequest(inputData, authHeaders, defaultError) {
  return postJson(
    apiPaths.automationManager,
    buildWorkflowRequestBody(inputData),
    authHeaders,
    { defaultError }
  );
}

export const workflowCatalogApi = (inputData, authHeaders) =>
  workflowChannelRequest(inputData, authHeaders, 'Failed to load workflow catalog');

export const listWorkflowsApi = (inputData, authHeaders) =>
  workflowChannelRequest(inputData, authHeaders, 'Failed to load workflows');

export const getWorkflowApi = (inputData, authHeaders) =>
  workflowChannelRequest(inputData, authHeaders, 'Failed to load workflow');

export const saveWorkflowApi = (inputData, authHeaders) =>
  workflowChannelRequest(inputData, authHeaders, 'Failed to save workflow');

export const deleteWorkflowApi = (inputData, authHeaders) =>
  workflowChannelRequest(inputData, authHeaders, 'Failed to delete workflow');

export const publishWorkflowApi = (inputData, authHeaders) =>
  workflowChannelRequest(inputData, authHeaders, 'Failed to publish workflow');

export const archiveWorkflowApi = (inputData, authHeaders) =>
  workflowChannelRequest(inputData, authHeaders, 'Failed to archive workflow');

export const pauseWorkflowApi = (inputData, authHeaders) =>
  workflowChannelRequest(inputData, authHeaders, 'Failed to pause workflow');

export const getTriggerConfigApi = (inputData, authHeaders) =>
  workflowChannelRequest(inputData, authHeaders, 'Failed to load trigger config');

export const saveTriggerConfigApi = (inputData, authHeaders) =>
  workflowChannelRequest(inputData, authHeaders, 'Failed to save trigger config');

export const saveCustomActionApi = (inputData, authHeaders) =>
  workflowChannelRequest(inputData, authHeaders, 'Failed to save custom action');

export const getWorkflowAnalyticsApi = (inputData, authHeaders) =>
  workflowChannelRequest(inputData, authHeaders, 'Failed to load workflow analytics');

export const getBasicAutomationsApi = (inputData, authHeaders) =>
  workflowChannelRequest(inputData, authHeaders, 'Failed to load basic automations');

export const saveBasicAutomationsApi = (inputData, authHeaders) =>
  workflowChannelRequest(inputData, authHeaders, 'Failed to save basic automations');
